import React from 'react';
import { motion } from 'framer-motion';
export function PromoSection() {
  return <section className="py-20 bg-white overflow-hidden" data-id="element-120">
      <div className="container mx-auto px-4 md:px-6 lg:px-8" data-id="element-121">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-122">
          {/* Text Content */}
          <motion.div className="w-full lg:w-1/2" initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} data-id="element-123">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-brand-navy leading-tight mb-6" data-id="element-124">
              Achetez plus
              <br data-id="element-125" />
              <span className="text-brand-navy" data-id="element-126">Payez moins !</span>
            </h2>
            <p className="text-lg text-gray-600 mb-8 max-w-lg leading-relaxed" data-id="element-127">
              Avec une large gamme de produits de haute qualité, AVENIR 2000
              vous permet de maximiser vos économies. Que vous soyez un
              professionnel ou un particulier, nos prix de gros s'adaptent à vos
              besoins. Plus vous commandez, plus les prix baissent.
            </p>
            <button className="text-brand-navy font-semibold border-b-2 border-brand-gold pb-1 hover:text-brand-gold transition-colors" data-id="element-128">
              Voir nos offres spéciales
            </button>
          </motion.div>

          {/* Image Composition */}
          <motion.div className="w-full lg:w-1/2 relative h-[400px] md:h-[500px]" initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-129">
            {/* Main Laptop */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3/4 max-w-[400px] z-20" data-id="element-130">
              <img src="https://images.unsplash.com/photo-1603302576837-37561b2e2302?auto=format&fit=crop&q=80&w=800" alt="Modern Laptop" className="w-full h-auto drop-shadow-2xl rounded-lg" data-id="element-131" />
            </div>

            {/* Secondary Laptop Left */}
            <div className="absolute top-1/4 left-0 w-1/2 max-w-[250px] z-10 opacity-80 blur-[1px] transform -rotate-6" data-id="element-132">
              <img src="https://images.unsplash.com/photo-1517336714731-489689fd1ca8?auto=format&fit=crop&q=80&w=600" alt="Macbook" className="w-full h-auto drop-shadow-xl rounded-lg" data-id="element-133" />
            </div>

            {/* Secondary Laptop Right */}
            <div className="absolute bottom-1/4 right-0 w-1/2 max-w-[250px] z-10 opacity-80 blur-[1px] transform rotate-6" data-id="element-134">
              <img src="https://images.unsplash.com/photo-1498049794561-7780e7231661?auto=format&fit=crop&q=80&w=600" alt="Electronics" className="w-full h-auto drop-shadow-xl rounded-lg" data-id="element-135" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}